import React from "react";

import { Breadcrumbs } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { colors } from "@zapalacorp/tokens";

import { BreadcrumbItemSpan, HeaderWrapper } from "./styles";

type BreadcrumbItem = {
  key: string;
  label: React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
};

type Props = {
  items: BreadcrumbItem[];
};

export const BreadcrumbKit: React.FC<Props> = ({ items }) => {
  return (
    <HeaderWrapper>
      <Breadcrumbs separator={<NavigateNext />} aria-label="breadcrumb">
        {items.map((item, index) => (
          <BreadcrumbItemSpan
            key={item.key}
            data-cy="linkToGoBackToPeopleTab"
            hasCursorPointer={!item.isDisabled && !!item?.onClick}
            color={index + 1 === items.length ? colors.gray800 : undefined}
            onClick={() => {
              if (!item.isDisabled) item.onClick?.();
            }}
          >
            {item.label}
          </BreadcrumbItemSpan>
        ))}
      </Breadcrumbs>
    </HeaderWrapper>
  );
};
